import { useOutletContext } from 'react-router-dom';
import { EmployeeDetail } from '@/components/employees/EmployeeDetail';
import type { AppShellContext } from '@/components/layout/AppShell';

export function EmployeeDetailPage() {
  const { nip } = useOutletContext<AppShellContext>();
  return <EmployeeDetail companyNip={nip} />;
}
